export function getBookingStatusLabel(status) {
  const normalized = String(status || '').toLowerCase().replaceAll('_', '');

  if (normalized === 'pending') return 'Pending';
  if (normalized === 'confirmed') return 'Confirmed';
  if (normalized === 'checkedin') return 'Checked In';
  if (normalized === 'completed') return 'Completed';
  if (normalized === 'cancelled') return 'Cancelled';

  return status || 'Booking';
}
